import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function WhyChooseUs() {
  const { t } = useTranslation();

  const reasons = [
    { number: t('about_r1_num'), title: t('about_r1_title'), desc: t('about_r1_desc') },
    { number: t('about_r2_num'), title: t('about_r2_title'), desc: t('about_r2_desc') },
    { number: t('about_r3_num'), title: t('about_r3_title'), desc: t('about_r3_desc') },
    { number: t('about_r4_num'), title: t('about_r4_title'), desc: t('about_r4_desc') },
    { number: t('about_r5_num'), title: t('about_r5_title'), desc: t('about_r5_desc') },
    { number: t('about_r6_num'), title: t('about_r6_title'), desc: t('about_r6_desc') },
  ];

  return (
    <section className="py-20 bg-slate-950">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in" className="text-center mb-14">
          <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase">{t('about_why_badge')}</span>
          <h2 className="text-4xl font-bold text-white mt-3 mb-3">{t('about_why_title')}</h2>
          <p className="text-slate-400 max-w-xl mx-auto">{t('about_why_desc')}</p>
        </AnimatedSection>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
          {reasons.map((r, i) => (
            <AnimatedSection key={r.number} animation="fade-in" delay={i * 0.08}>
              <div className="bg-slate-800/50 border border-slate-700 hover:border-cyan-500/30 rounded-2xl p-7 transition-all group">
                <div className="text-5xl font-bold text-slate-700 group-hover:text-cyan-500/30 transition-colors mb-4">{r.number}</div>
                <h3 className="text-white font-bold mb-2">{r.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{r.desc}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
        <AnimatedSection animation="fade-in" className="text-center">
          <Link to="/contact" className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-bold px-8 py-4 rounded-lg transition-all whitespace-nowrap cursor-pointer inline-block">
            {t('about_why_cta')}
          </Link>
        </AnimatedSection>
      </div>
    </section>
  );
}
